import type { ChangeEvent } from 'react'

export const maxNameLength = 30

/**
 * Het naamveld met de onderlijn: display-font, groot, en een rand die op
 * terracotta springt zodra er iets staat. Komt terug op "Wie ben je?" en in
 * "Naam aanpassen".
 *
 * Een echte `<input>` en geen contenteditable: autocomplete, de
 * "klaar"-knop op het toetsenbord van een telefoon en spraakinvoer werken
 * alleen op het echte element.
 */
export function NameField({
  value,
  onChange,
  id = 'naam',
  size = 'md',
  autoFocus = false,
}: {
  value: string
  onChange: (value: string) => void
  id?: string
  size?: 'md' | 'lg'
  autoFocus?: boolean
}) {
  const filled = value.trim().length > 0

  return (
    <>
      <label
        htmlFor={id}
        className="text-ink-faint mb-2.5 block text-[11px] tracking-[0.18em] uppercase sm:text-xs"
      >
        Jouw naam
      </label>

      <input
        id={id}
        type="text"
        inputMode="text"
        enterKeyHint="done"
        autoComplete="name"
        autoCapitalize="words"
        autoCorrect="off"
        spellCheck={false}
        // Dit scherm bestaat uit precies één veld. De cursor er niet in zetten
        // kost elke gast een extra tik, op een telefoon in het donker.
        autoFocus={autoFocus}
        maxLength={maxNameLength}
        value={value}
        placeholder="bv. Tante Marleen"
        onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
        className={
          'font-display text-ink caret-accent w-full border-b bg-transparent pb-3 ' +
          'placeholder:text-ink-ghost outline-none placeholder:italic ' +
          (size === 'lg' ? 'text-[28px] sm:text-[34px]' : 'text-[28px] sm:text-[32px]') +
          ' ' +
          (filled ? 'border-accent' : 'border-line')
        }
      />
    </>
  )
}
